import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { RequireAuth } from '../guards/Guards';
import AppHeader from '../components/AppHeader';
import AppSidebar from '../components/AppSidebar';

/**
 * App plate: header + sidebar + content. Shown only when authenticated.
 */
export default function AppLayout() {
  return (
    <RequireAuth>
      <div className="app-layout">
        <div className="app-main">
        <AppHeader />
        <div className="d-flex">
        <AppSidebar />
        <main className="app-content">
          <Outlet />
        </main>
        </div>
        </div>
      </div>
    </RequireAuth>
  );
}
